// Skjemaverdier (tekst) for bilkortet, og oversettelse til det saveOrgVehicle forventer.
// Serveren (carrierValidation.validateVehicleInput) er fasit. Dette er rask feedback i skjemaet.

export const EMPTY_VEHICLE_FORM = {
  registrationPlate: '', make: '', bodyType: 'tipper', fuelType: 'diesel',
  axles: '', curbWeightKg: '', legalPayloadKg: '', legalGrossWeightKg: '',
  nextInspectionDate: '', defaultDriverUid: '',
  status: 'active', outOfServiceReason: '', outOfServiceFrom: '', outOfServiceUntil: '',
};

const str = (v) => (v === null || v === undefined ? '' : String(v));

export function formFromVehicle(v) {
  return {
    registrationPlate: str(v.registrationPlate), make: str(v.make),
    bodyType: v.bodyType ?? 'tipper', fuelType: v.fuelType ?? 'diesel',
    axles: str(v.axles), curbWeightKg: str(v.curbWeightKg), legalPayloadKg: str(v.legalPayloadKg),
    legalGrossWeightKg: str(v.legalGrossWeightKg), nextInspectionDate: str(v.nextInspectionDate),
    defaultDriverUid: str(v.defaultDriverUid),
    status: v.status === 'out_of_service' ? 'out_of_service' : 'active',
    outOfServiceReason: str(v.outOfServiceReason), outOfServiceFrom: str(v.outOfServiceFrom), outOfServiceUntil: str(v.outOfServiceUntil),
  };
}

const toInt = (s) => (String(s).trim() === '' ? NaN : Number(s));

export function payloadFromForm(f) {
  const away = f.status === 'out_of_service';
  return {
    registrationPlate: f.registrationPlate, make: f.make, bodyType: f.bodyType, fuelType: f.fuelType,
    axles: toInt(f.axles), curbWeightKg: toInt(f.curbWeightKg),
    legalPayloadKg: toInt(f.legalPayloadKg), legalGrossWeightKg: toInt(f.legalGrossWeightKg),
    nextInspectionDate: f.nextInspectionDate, defaultDriverUid: f.defaultDriverUid || null,
    status: f.status,
    outOfServiceReason: away ? f.outOfServiceReason : null,
    outOfServiceFrom: away ? (f.outOfServiceFrom || null) : null,
    outOfServiceUntil: away ? (f.outOfServiceUntil || null) : null,
  };
}

const posInt = (s) => Number.isInteger(toInt(s)) && toInt(s) > 0;

export function validateVehicleForm(f) {
  const errors = {};
  if (!/^[A-Z0-9]{2,8}$/.test(f.registrationPlate.toUpperCase().replace(/\s+/g, ''))) errors.registrationPlate = 'Skriv inn gyldig skiltnummer';
  if (!f.make.trim()) errors.make = 'Skriv inn bilmerke';
  const axles = toInt(f.axles);
  if (!Number.isInteger(axles) || axles < 2 || axles > 9) errors.axles = 'Antall aksler må være mellom 2 og 9';
  if (!posInt(f.curbWeightKg)) errors.curbWeightKg = 'Skriv inn egenvekt i kg';
  if (!posInt(f.legalPayloadKg)) errors.legalPayloadKg = 'Skriv inn lovlig nyttelast i kg';
  if (!posInt(f.legalGrossWeightKg) || (posInt(f.curbWeightKg) && toInt(f.legalGrossWeightKg) < toInt(f.curbWeightKg))) {
    errors.legalGrossWeightKg = 'Lovlig bruttovekt må være minst egenvekten';
  }
  if (!/^\d{4}-\d{2}-\d{2}$/.test(f.nextInspectionDate)) errors.nextInspectionDate = 'Velg dato for neste EU-kontroll';
  if (f.status === 'out_of_service' && !f.outOfServiceReason.trim()) errors.outOfServiceReason = 'Skriv inn årsak';
  return errors;
}
